/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import InlineResponse2008 from '../model/InlineResponse2008';
import NeeDocuments from '../model/NeeDocuments';

/**
* NeeDocuments service.
* @module api/NeeDocumentsApi
* @version 1.0.0
*/
export default class NeeDocumentsApi {

    /**
    * Constructs a new NeeDocumentsApi. 
    * @alias module:api/NeeDocumentsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * insert
     * store nee documents
     * @param {Number} studentId Student Id
     * @param {Object} opts Optional parameters
     * @param {Number} opts.neeLevelId 
     * @param {File} opts.files 
     * @param {String} opts.moreInfo 
     * @param {Boolean} opts.replica 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2008} and HTTP response
     */
    neeDocumentControllerStoreWithHttpInfo(studentId, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling neeDocumentControllerStore");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'nee_level_id': opts['neeLevelId'],
        'files': opts['files'],
        'more_info': opts['moreInfo'],
        'replica': opts['replica']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = InlineResponse2008;
      return this.apiClient.callApi(
        '/nee-documents/students/{student_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * insert
     * store nee documents
     * @param {Number} studentId Student Id
     * @param {Object} opts Optional parameters
     * @param {Number} opts.neeLevelId 
     * @param {File} opts.files 
     * @param {String} opts.moreInfo 
     * @param {Boolean} opts.replica 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2008}
     */
    neeDocumentControllerStore(studentId, opts) {
      return this.neeDocumentControllerStoreWithHttpInfo(studentId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * get nee info from student
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/NeeDocuments} and HTTP response
     */
    neeDocumentsControllerGetNeeDataWithHttpInfo(studentId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling neeDocumentsControllerGetNeeData");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = NeeDocuments;
      return this.apiClient.callApi(
        '/nee-documents/students/{student_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get nee info from student
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/NeeDocuments}
     */
    neeDocumentsControllerGetNeeData(studentId) {
      return this.neeDocumentsControllerGetNeeDataWithHttpInfo(studentId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Descargar un documento de necesidades educativas especiales
     * Permite descargar un documento específico de necesidades educativas especiales de un estudiante.
     * @param {Number} studentId ID del estudiante
     * @param {Number} documentId ID del documento a descargar
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
    studentsStudentIdDocumentsDocumentIdDownloadGetWithHttpInfo(studentId, documentId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling studentsStudentIdDocumentsDocumentIdDownloadGet");
      }
      // verify the required parameter 'documentId' is set
      if (documentId === undefined || documentId === null) {
        throw new Error("Missing the required parameter 'documentId' when calling studentsStudentIdDocumentsDocumentIdDownloadGet");
      }

      let pathParams = {
        'student_id': studentId,
        'document_id': documentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/octet-stream', 'application/json'];
      let returnType = File;
      return this.apiClient.callApi(
        '/students/{student_id}/documents/{document_id}/download', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Descargar un documento de necesidades educativas especiales
     * Permite descargar un documento específico de necesidades educativas especiales de un estudiante.
     * @param {Number} studentId ID del estudiante
     * @param {Number} documentId ID del documento a descargar
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
    studentsStudentIdDocumentsDocumentIdDownloadGet(studentId, documentId) {
      return this.studentsStudentIdDocumentsDocumentIdDownloadGetWithHttpInfo(studentId, documentId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
